export enum SelfServiceProcess {
  CHANGE_EMAIL_PAGE = 'CHANGE_EMAIL_PAGE',
  CHANGE_EMAIL_PAGE_EXTERNAL = 'CHANGE_EMAIL_PAGE_EXTERNAL',
  CHANGE_PASSWORD_PAGE = 'CHANGE_PASSWORD_PAGE',
  CHANGE_USERNAME_PAGE = 'CHANGE_USERNAME_PAGE',
  CHANGE_SERVICECODEINPUT_PAGE = 'CHANGE_SERVICECODEINPUT_PAGE',
  CHANGE_SERVICECODEREQUEST_PAGE = 'CHANGE_SERVICECODEREQUEST_PAGE',
  CHANGE_NAME_PAGE = 'CHANGE_NAME_PAGE',
  CHANGE_ADDRESS_PAGE = 'CHANGE_ADDRESS_PAGE',
  CHANGE_BANKDATA_PAGE = 'CHANGE_BANKDATA_PAGE',
  CHANGE_ADVERTISING_CONSENT_PAGE = 'CHANGE_ADVERTISING_CONSENT_PAGE',
  CHANGE_MOTORVERSICHERUNGSUMFANG_PAGE = 'CHANGE_MOTORVERSICHERUNGSUMFANG_PAGE',
  CHANGE_MOTORFAHRLEISTUNG_PAGE = 'CHANGE_MOTORFAHRLEISTUNG_PAGE',
  CHANGE_MOTORFAHRERKREIS_PAGE = 'CHANGE_MOTORFAHRERKREIS_PAGE',
  REQUEST_DIGITALCARD_PAGE = 'REQUEST_DIGITALCARD_PAGE',
  REQUEST_IVK_PAGE = 'REQUEST_IVK_PAGE',
  REQUEST_ACCOMPANYINGDRIVINGCERTIFICATE_PAGE = 'REQUEST_ACCOMPANYINGDRIVINGCERTIFICATE_PAGE',
  REQUEST_VEHICLESALE_PAGE = 'REQUEST_VEHICLESALE_PAGE',
  REQUEST_TERMINATION_PAGE = 'REQUEST_TERMINATION_PAGE'
}

export interface ProcessReturnContext {
  process: SelfServiceProcess
  policyIds: string[]
}
